import {useNavigate} from '@tanstack/react-router';
import {useEffect} from 'react';
import FullScreenLoadingIndicator from '../FullScreenLoadingIndicator';
import {useUser} from '../Providers/JWTProvider';

const SignOut = () => {
    const navigate = useNavigate();
    const {user, logout} = useUser();

    useEffect(() => {
        if (user !== null) {
            logout();
            navigate({to: '/signin'});
        } else {
            navigate({to: '/'});
        }
    }, [navigate]);

    return <FullScreenLoadingIndicator />;
};

export default SignOut;
